export default __webpack_public_path__ + "static/media/1.c5562298.jpg";